<template>
  <div class="cencent login_body">


    <div class="loginleft">

      <div class="login_box">


        <div class="title-desc">
          {{ desc }}
        </div>
        <div class="login_title">
          手机验证码登录
        </div>
        <div>
          <el-form ref="form" :model="form" label-width="20px">
            <el-form-item>
              <el-input v-model="form.phone" clearable maxlength="11" placeholder="请输入手机号" class="inputk" style="width:100%;"></el-input>
            </el-form-item>

            <el-form-item>
              <div style="display: flex;justify-content: space-between;flex-wrap: unset">
                <div style="width: 100%">
                  <el-input v-model="form.code" placeholder="请输入验证码" maxlength="5" class="inputk"></el-input>
                </div>
                <div style="color:#2E6CFF;text-align: center;width: 0%;cursor: pointer;position: relative;right: 40px;white-space:nowrap" @click="get_code()">
                  {{ codemsg }}
                </div>
              </div>
            </el-form-item>
            <el-form-item>
              <div style="height: 20px">

              </div>
              <div style="text-align: center">

                <el-button style="
                width: 100%;
              background:#2E6CFF;
              color: #F1F1F1;
              border-radius: 8px 8px 8px 8px;" @click="login"> 登录
                </el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>

      </div>
    </div>

    <!--    <div style="width: 60%" class="login_right">-->

    <!--      <div style="position: absolute;bottom: 340px;text-align: center;width: 60%;font-size: 80px;color: #FFFFFF;font-weight: bold">-->
    <!--        <p></p>-->
    <!--        <p style="font-size: 24px">智能·高效·快捷·轻巧</p>-->
    <!--      </div>-->
    <!--    </div>-->

  </div>
</template>

<script>
import u from "../../../assets/js/util"

export default {
  name: "index",
  data() {
    return {
      codemsg: "获取",
      desc: "",
      form: {
        phone: "",
        code: ""
      }
    }
  },
  async mounted() {


    var host = location.host
    var systeminfo = await u.get_no("admin", "getsysteminfo", host)
    if (systeminfo) {
      document.title = systeminfo.systemName
      this.desc = systeminfo.logindesc
    }
    var user = await u.post("users", "getuserinfo", {}, 1, 1, 1)
    if (user !== false) {
      window.userinfo = user
      this.$router.push('/index')
    }


  }
  ,
  methods: {

    async login() {

      if (!u.isPhone(this.form.phone)) {
        u.error("手机号格式不正确")
        return;
      }
      if (!this.form.code) {
        u.error("验证码不能空")
        return;
      }

      var data = await u.post("users", u.config().loginfund, {phone: this.form.phone, code: this.form.code})

      if (data !== false) {
        // document.cookie = "AUTH=" + data.auth+";expires="+(6000*60*24*30)
        setCookie("AUTH", data.auth, 60 * 60 * 24 * 30)
        window.userinfo = data.userinfo
        this.$router.push('/index')
      }
    },
    async get_code() {
      if (!u.isPhone(this.form.phone)) {
        u.error("手机号格式不正确")
        return;
      }

      if (this.codemsg != "获取") {
        return
      }
      this.codemsg = 60
      var stl = setInterval(() => {
        this.codemsg = this.codemsg - 1

        if (this.codemsg <= 0) {
          this.codemsg = "获取"
          clearInterval(stl)
        }
      }, 1000)
      var data = await u.post("users", "getcode_admin", {phone: this.form.phone, temp: "640013"})
      if (data === false) {
        u.error("获取失败")
        clearInterval(stl)
        this.codemsg = "获取"
        return
      }
    }
  }
}

function setCookie(name, val, min) {
  var now = new Date();
  //设置时间
  now.setMinutes(now.getMinutes() + min)

  //设置Cookie
  document.cookie = name + '=' + val + ';expires=' + now.toUTCString()
}
</script>

<style scoped>
.login_body {
  /*background-color: #FFFFFF;*/
  width: 100%;
  display: flex;

  background-image: url(https://file.sumou.fun/homeadmin/login/loginback.png);
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}

.login_title {
  margin-top: 20px;
  padding: 40px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: bold;
  font-size: 18px;
  color: #000000;
  line-height: 21px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.title-desc {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
  line-height: 19px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

.title-login {
  font-weight: 600;
  font-size: 40px;
  white-space: nowrap;
  color: #000000;
  line-height: 47px;
  font-style: normal;
  text-transform: none;
}

.login_box {

  width: 449px;
  height: 350px;
  background: #FFFFFF;
  border-radius: 8px;
  margin-left: 88px;
  margin-top: 210px;
  padding: 40px;

  /*text-align: center;*/
  /*width: 400px;*/
  /*height: 600px;*/
  /*margin: 0 auto;*/
  /*margin-top: 100px;*/
  /*border-radius: 10px;*/
}

.inputk {
}

/*.login_right {*/
/*  background-image: url(../../../assets/login/loginbanck.png);*/
/*  width: 100%;*/
/*  height: 100%;*/
/*  background-size: cover;*/
/*  background-position: center;*/

/*}*/

/*.loginleft {*/
/*  width: 40%;*/
/*  height: 100%;*/
/*}*/

/*/deep/ .el-input__inner {*/
/*  border: 0;*/
/*}*/

/deep/ .el-input__inner {
  background-color: #F1F1F1;
  border: 0;
  border-radius: 8px 8px 8px 8px;
}
</style>



// WEBPACK FOOTER //
// src/page/module/login/login.vue